import { render, staticRenderFns } from "./game-config.vue?vue&type=template&id=cf64af70&scoped=true&lang=pug&"
import script from "./game-config.vue?vue&type=script&lang=ts&"
export * from "./game-config.vue?vue&type=script&lang=ts&"
import style0 from "./game-config.vue?vue&type=style&index=0&id=cf64af70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf64af70",
  null
  
)

export default component.exports